import styled from '@emotion/styled';

export const HEADER_HEIGHT = 56;
const HEIGHT = 65;
export const LOGO_SIZE = 176;
export const SHADOW_HEIGHT = 20;
const SPACE_BOTTOM = LOGO_SIZE - HEIGHT + SHADOW_HEIGHT;

export const ScrollSpaceReservator = styled.div`
  height: ${LOGO_SIZE + HEADER_HEIGHT}px;
  margin-bottom: ${({ theme }) => theme.spacing(5)};
`;

export const BorderBottom = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.neutrals.grey8};
`;

export const Root = styled.div`
  position: fixed;
  top: ${HEADER_HEIGHT}px;
  width: 100%;
  transition: transform 0.3s ease-in-out;
  transform: translateY(-${LOGO_SIZE + SHADOW_HEIGHT}px);

  &[data-visible="true"] {
    transform: translateY(0);
  }
`;

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  filter: drop-shadow(0 2px 5px rgba(0, 0, 0, 0.06)) drop-shadow(0 2px 20px rgba(0, 0, 0, 0.05));
  clip-path: inset(0px 0px -${SPACE_BOTTOM}px 0px);
`;

export const Subheader = styled.div`
  height: ${HEIGHT}px;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.neutrals.white};
`;

export const LogoWrapper = styled.div`
  margin-top: -${HEIGHT}px;
  position: relative;
  width: 176px;
  height: 176px;
  background-color: ${({ theme }) => theme.colors.neutrals.white};
  border-radius: 50%;
  z-index: 1;

  &::before, &::after {
    content: '';
    position: absolute;
    top: 55px;
    width: 48px;
    height: 48px;
    background: white;
  }

  &::before {
    left: -37px;
    mask: radial-gradient(circle at 0 100%, transparent 38px, black 38px);
  }

  &::after {
    right: -37px;
    mask: radial-gradient(circle at 100% 100%, transparent 38px, black 38px);
  }
`;

export const Logo = styled.img`
  border-radius: 50%;
`;
